import React from 'react'

import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import { Store, getLoginView, LoginView } from '../../reducers/index'
import { hideLoginForm, showLoginForm } from '../../actions/ui_actions'
import { Action } from '../../actions/types'

import Login from './Login'
import LoginViewSelect from './Select'
import SignUp from './SignUp'
import Registered from './Registered'

type LoginProps = {
  hide: () => Action
  showView: (view: LoginView) => Action
  view: LoginView
  forceLogin?: boolean
}

class LoginManager extends React.Component<LoginProps> {
  static contextTypes = {
    client: () => null
  }

  showLogin = () => {
    this.props.showView('login')
  }

  showSignup = () => {
    this.props.showView('signup')
  }

  render() {
    const { hide, view, showView, forceLogin } = this.props

    if (view === 'none' && forceLogin) {
      return <Login />
    }

    switch (view) {
      case 'login':
        return <Login />
      case 'signup':
        return <SignUp />
      case 'registered':
        return <Registered />
      case 'select':
        return <LoginViewSelect hide={hide} showView={showView} />
      default:
        return null
    }
  }
}

const mapStateToProps = (state: Store.Complete) => ({
  view: getLoginView(state)
})

const mapDispatchToProps = (dispatch: Dispatch<Store.Complete>) => ({
  hide: () => dispatch(hideLoginForm()),
  showView: (view: LoginView) => dispatch(showLoginForm(view))
})

export default connect(mapStateToProps, mapDispatchToProps)(LoginManager)



// WEBPACK FOOTER //
// ./src/Components/LoginForm/index.tsx